export default __webpack_public_path__ + "static/cover-image-787888b1793f77cd1803ca079a960ac1.png";